var isSaveing = false;
export default (filename, blob,cover,userid,filelists_local,filelists_covers,filelists_localsid) => {
     if(isSaveing)
     {
      alert("上次作品正在上传中");
     }
     isSaveing = true;
     var uploadurl;
    //设置BLOG转化为文件
    var file = new File([blob], filename, {type: "", lastModified: Date.now()});
    const updateurl=window.scratchConfig.localhost+"/scratch/files/saveold"
    //设置转化为FORMDATA提交
    var tempdata=new FormData();
    tempdata.append("scratch",file);
    tempdata.append("covers",cover);
    tempdata.append("userid",userid);
    tempdata.append("filelists_title",filename);
    tempdata.append("filelists_localsid",filelists_localsid);
    tempdata.append("filelists_local",filelists_local);
    tempdata.append("filelists_covers",filelists_covers);
    
    fetch(updateurl,{
         method: 'POST',

       body:tempdata,
    }) .then((response) => {
            isSaveing = false;
            return response.json()
        }).then((res) => {
            if(res.status == 'success'){
                    alert(res.msg);
                    window.scratchConfig.filelists_local=res.localsname;
                    window.scratchConfig.filelists_covers=res.covers;
                    window.scratchConfig.filelists_localsid=res._id;
            }
            else
            {
                 alert(res.msg);
            }
        }).catch((error) => {
                alert(error);
        })

    
    
};
